import React from 'react';
import PropTypes from 'prop-types';

const AadhaarMasking = ({ fill, ...props }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M24.1504 4.10645H3.8504C3.51026 4.11252 3.17465 4.18554 2.86274 4.32134C2.55082 4.45715 2.26872 4.65307 2.03254 4.89792C1.79636 5.14276 1.61073 5.43174 1.48625 5.74835C1.36177 6.06495 1.30088 6.40297 1.30707 6.74311V21.2564C1.30088 21.5966 1.36177 21.9346 1.48625 22.2512C1.61073 22.5678 1.79636 22.8568 2.03254 23.1016C2.26872 23.3465 2.55082 23.5424 2.86274 23.6782C3.17465 23.814 3.51026 23.887 3.8504 23.8931H24.1504C24.4905 23.887 24.8262 23.814 25.1381 23.6782C25.45 23.5424 25.7321 23.3465 25.9683 23.1016C26.2044 22.8568 26.3901 22.5678 26.5146 22.2512C26.639 21.9346 26.6999 21.5966 26.6937 21.2564V6.74311C26.6999 6.40297 26.639 6.06495 26.5146 5.74835C26.3901 5.43174 26.2044 5.14276 25.9683 4.89792C25.7321 4.65307 25.45 4.45715 25.1381 4.32134C24.8262 4.18554 24.4905 4.11252 24.1504 4.10645ZM24.1504 21.2564H3.8504V6.74311H24.1504V21.2564Z"
      fill={fill || '#6B6C7B'}
    />
    <path
      d="M16.2518 12.4443H8.63794C7.30401 12.4443 6.22266 13.8306 6.22266 15.5407V15.5702C6.22266 17.2803 7.30401 18.6666 8.63794 18.6666H16.2518C17.5857 18.6666 18.6671 17.2803 18.6671 15.5702V15.5407C18.6671 13.8306 17.5857 12.4443 16.2518 12.4443Z"
      fill={fill || '#6B6C7B'}
    />
  </svg>
);

AadhaarMasking.propTypes = {
  fill: PropTypes.string,
};

export default AadhaarMasking;
